export default __webpack_public_path__ + "b9841f2ba4dbc2a81e29affc31dc0b33.png";